import { Attributes, List, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class GenerateTermsAndConditionsCommand extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Nullable()
    public approvalId: number | null = 0;

    @Rules.Required()
    public investorInvestmentId: number | null = 0;

    @Rules.Required()
    public mergeTemplateId: number | null = null;

    @Attributes.Integer()
    public timezoneOffset: number = new Date().getTimezoneOffset();

    public signingContacts = new List(TermsAndConditionsContact);

    // Client only properties / methods

    public addSignatory(contactType: string, contactTypeId: number | null) {
        const contact = new TermsAndConditionsContact();
        contact.contactType = contactType;
        contact.contactTypeId = contactTypeId;
        this.signingContacts.push(contact);
    }

    protected static addBusinessRules(rules: Validation.Rules<GenerateTermsAndConditionsCommand>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Generate Terms And Conditions Command";
    }
}

export class TermsAndConditionsContact extends ValueObject  {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Integer()
    @Attributes.Nullable()
    public contactId: number | null = null;

    @Attributes.Nullable()
    public contactTitleId: number | null = null;

    public contactName: string | null = "";

    // Client only properties / methods

    @Attributes.NoTracking()
    public contactType: string = "";

    @Attributes.NoTracking()
    public contactTypeId: number | null = null;
}